<template>
  <main class="c-main">
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <header class="card-header">
            <h4 class="pull-right">Добавить категорию</h4>
          </header>
          <div class="card-body">
            <div class="row">
              <div class="col-md-6">
                <form autcomplete="off" @submit.prevent="productStore()">
                  <div class="form-group">
                    <label>titleRus</label>
                    <input type="text" class="form-control" v-model="product.title" autofocus/>
                  </div>
                  <!-- <div class="form-group">
                    <label>titleUzl</label>
                    <input type="text" class="form-control" v-model="product.titleUzl" />
                  </div>
                  <div class="form-group">
                    <label>titleUzk</label>
                    <input type="text" class="form-control" v-model="product.titleUzk" />
                  </div>
                  <div class="form-group">
                    <label>version</label>
                    <input type="text" class="form-control" v-model="product.version" />
                  </div> -->
                  <div class="form-group">
                    <label>code</label>
                    <input type="text" class="form-control" v-model="product.code" />
                  </div>
                  <button type="submit" class="btn btn-primary">Добавить</button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import { GET, POST } from "../../shared/api";
export default {
  data() {
    return {
      product: {
        category_id: this.$route.params.category_id
      },
      categories: []
    };
  },
  methods: {
    getCategories() {
      GET([], "/category", this, false).then(response => {
        this.categories = response;
      });
    },
    productStore() {
      POST(this.product, "/product", this).then(response => {
        this.$router.push({ name: "productsByCategory" });
      });
    }
  },
  created() {
    this.getCategories();
  },
  mounted() {
    	let input = document.querySelector('[autofocus]');
        if (input) {
        	input.focus();
        }
    }
};
</script>
